module.exports = __webpack_public_path__ + "img/palani-grey.3cdfec9.webp";